// Route guard for the Members management page. Allowed for anyone with
// member-management authority — Publishers (courses/practices/groups) and
// Event Leaders (their own events). gw enforces the per-tab checks.
import { useRole } from '../app/RoleContext';
import AccessDenied from './AccessDenied';

export default function RequireMemberManager({ children }) {
  const { canManageGroups, canCreateEvents } = useRole();
  if (canManageGroups || canCreateEvents) return children;
  return (
    <AccessDenied title="Manager access required">
      Members management is available to Publishers (courses, practices, groups)
      and Event Leaders (events). A superadmin can grant either role from the
      Members page.
    </AccessDenied>
  );
}
